/* istanbul ignore next */
export const sideNavTheme = ({ sideNav = {} }) => ({
  ...sideNav,
  activeHighlightColor: sideNav?.activeLinkBackground || '#4dc5d7'
});

export default sideNavTheme;
